<template>
  <div >
    <top></top>
    <div class="bg_wrap">
      <topPiece></topPiece>
      <div class="container"  v-loading="loading">
<!--        <template v-if="!detail_show">-->
<!--          <titleConfig-->
<!--              :title="langSet == 'cn' ? '产品名录' : 'Product List'"-->
<!--              :type="2"-->
<!--          ></titleConfig>-->
<!--          <div class="_search">-->
<!--            <Select_input_search-->
<!--                :options="search_options"-->
<!--                :placeholder_select="placeholder_select"-->
<!--                :placeholder_input="placeholder_input"-->
<!--                :select_key="'id'"-->
<!--                :select_label="-->
<!--                langSet == 'cn' ? 'category_name' : 'en_category_name'-->
<!--              "-->
<!--                :label_list="label_list"-->
<!--                @query_change="query_change"-->
<!--            ></Select_input_search>-->
<!--          </div>-->
<!--          &lt;!&ndash;        <div class="content_list">&ndash;&gt;-->
<!--          &lt;!&ndash;          <div class="list_item" v-for="(item,index) in productLists" :key="index" @click="item_click(item)">&ndash;&gt;-->
<!--          &lt;!&ndash;            <div class="image_box">&ndash;&gt;-->
<!--          &lt;!&ndash;              <el-image class="item_img" :src="item.image"></el-image>&ndash;&gt;-->
<!--          &lt;!&ndash;            </div>&ndash;&gt;-->
<!--          &lt;!&ndash;            <div class="item_text1 margin_bottom">{{ item.product_name }}</div>&ndash;&gt;-->
<!--          &lt;!&ndash;            <div class="item_text2 margin_bottom">{{ '产品类别：' + item.categoryNameCnEn.category_name }}</div>&ndash;&gt;-->
<!--          &lt;!&ndash;          </div>&ndash;&gt;-->
<!--          &lt;!&ndash;        </div>&ndash;&gt;-->
<!--          <Product_list-->
<!--              :productLists="productLists"-->
<!--              @item_click="item_click"-->
<!--          ></Product_list>-->
<!--          <nodata v-if="productLists.length == 0"></nodata>-->
<!--          <div class="block">-->
<!--            <el-pagination-->
<!--                @size-change="sizeChange"-->
<!--                @current-change="currentChange"-->
<!--                :page-sizes="[8, 16, 32]"-->
<!--                :page-size="pageSize"-->
<!--                layout="prev, pager, next,sizes"-->
<!--                :total="total"-->
<!--            >-->
<!--            </el-pagination>-->
<!--          </div>-->
<!--        </template>-->
        <template >
          <titleConfig :title="'产品详情'" :type="2"></titleConfig>
          <div class="company_box">
            <div class="company_box_left">
              <div class="_left_image_box">
                <img class="image_left" :src="detail_company.cover" alt="" />
              </div>
              <div class="mobile_div">
                <div class="company_title">{{ detail_company.title }}</div>
                <div class="mobile_flex flex">
                  <div class="company_booth_no">
                    {{
                      langSet == "cn"
                          ? "展位号："
                          : "Booth No：" + detail_company.booth_no
                    }}
                  </div>
                  <div class="company_enterprise_type">
                    {{
                      langSet == "cn"
                          ? "展位类别：" + detail_company.enterprise_type
                          : "Booth category：" + detail_company.enterprise_type_en
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="see_button" @click="see_button">
              {{ langSet == "cn" ? "查看详情" : "View details" }}
            </div>
          </div>
          <div class="product_content">
            <Content_top
                :title="langSet == 'cn' ? '产品详情' : 'Product Details'"
            ></Content_top>
            <div class="content_middle">
              <div class="middle_image_box">
                <el-image
                    class="middle_image"
                    :src="product_detail.image"
                ></el-image>
              </div>
              <div class="text_right">
                <div class="margin_bottom20">
                  {{
                    langSet == "cn"
                        ? product_detail.product_name
                        : product_detail.en_product_name
                  }}
                </div>
                <div class="mobile_btn flex">
                  <div
                      :class="[
                      'Collection',
                      'margin_bottom20',
                      product_detail.is_collect == 0 ? '' : 'Collection_change',
                    ]"
                      @click="collect"
                  >
                    <div>
                      {{
                        product_detail.is_collect == 0
                            ? langSet == "cn"
                                ? "收藏"
                                : "collect"
                            : langSet == "cn"
                                ? "已收藏"
                                : "Collected"
                      }}
                    </div>
                    <div>|</div>
                    <img
                        class="Collection_image"
                        src="@/assets/aixin.png"
                        alt=""
                    />
                  </div>
                  <div class="Request" @click="request_click">
                    {{ langSet == "cn" ? "索取样品" : "Asking Samples" }}
                  </div>
                </div>
                <div class="introduce_text margin_bottom20">
                  {{
                    langSet == "cn"
                        ? "产品类别：" +
                        product_detail.categoryNameCnEn.category_name
                        : "Product Category：" +
                        product_detail.categoryNameCnEn.en_category_name
                  }}
                </div>
                <div class="introduce_text margin_bottom20">
                  {{
                    langSet == "cn"
                        ? "产品介绍：" + product_detail.introduction
                        : "Product Introduction" + product_detail.introduction_en
                  }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>

      <el-dialog
          v-if="dialogVisible"
          :title="
          langSet == 'cn'
            ? '请填写您的索样信息'
            : 'Please fill in your sample request information'
        "
          :visible.sync="dialogVisible"
          width="30%"
          :before-close="handleClose"
      >
        <div>
          <div class="line"></div>
          <div class="dialog_box_top">
            <div class="title_picture">
              <img :src="userInfo.avatar_uri" alt="" />
              <img
                  v-if="userInfo.exhibitor_long_id"
                  src="@/assets/authentication.png"
                  alt=""
              />
            </div>
            <div style="color: #ffffff">
              <div class="title_name">
                <div>{{ userInfo.nickname }}</div>
                <div>{{ userInfo.position }}</div>
              </div>
              <div class="company">{{ userInfo.company_name }}</div>
            </div>
            <!--            <img class="edit_img" src="@/assets/edit.png" alt="" />-->
          </div>
          <el-input
              type="textarea"
              :rows="7"
              :placeholder="
              langSet == 'cn'
                ? '请详细描述您的需求'
                : 'Please provide a detailed description of your requirements'
            "
              v-model="request_content"
          >
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <!--    <el-button @click="dialogVisible = false">取 消</el-button>-->
          <el-button class="submit" type="primary" @click="submit">{{
              langSet == "cn" ? "提 交" : "Submit"
            }}</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>


<script>
import top from "@/components/top.vue";
import titleConfig from "@/components/title.vue";
import topPiece from "@/components/topPiece.vue";
import {
  categoryLists,
  MemberConsultation_add,
  product_detail,
  product_lists,
} from "@/api/product_api";
import bottom from "@/components/bottom.vue";
import Select_input_search from "@/components/Select_input_search.vue";
import { company_detail } from "@/api/company_api";
import { dict_lists, public_collect } from "@/api/api";
import Product_list from "@/views/product/component/product_list.vue";
import nodata from "@/components/nodata.vue";
import Content_top from "@/components/content_top.vue";
import router from "@/router";
import fa from "element-ui/src/locale/lang/fa";

export default {
  name: "product",
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    Content_top,
    // nodata,
    // Product_list,
    bottom,
    titleConfig,
    top,
    topPiece,
    // Select_input_search,
  },
  data() {
    return {
      langSet: 'cn',
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      flag: localStorage.getItem("Flag") || "",
      loading: false,
      pageSize: 8,
      pageNo: 1,
      total: 0,
      productLists: [],
      label_name: "",
      cid: "",
      search_options: [],
      placeholder_select: "请选择产品类别",
      placeholder_input: "搜索产品名称或关键词",
      product_name: "",
      en_product_name: "",
      product_detail: {},
      detail_company: {},
      detail_show: false,
      dialogVisible: false,
      request_content: "",
      label_list: [],
      label_value: "",
      metaData: {},
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
        menuArr,
        (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = this.$language;
    let query = this.$route.query;
    if (query.detail_show) {
      this.go_to_detail(query);
    } else {
      // this.get_lists();
      // this.get_categoryLists();
      // this.get_dict_lists();
    }
    // this.placeholder_select =
    //     this.langSet == "cn" ? "请选择产品类别" : "Product Category";
    // this.placeholder_input =
    //     this.langSet == "cn"
    //         ? "搜索产品名称或关键词"
    //         : "Search for product name or keywords";
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
          .map((item) => {
            if (condition(item)) return item;

            // 处理嵌套数组
            if (Array.isArray(item.children)) {
              const nestedResult = this.findInNestedArray(
                  item.children,
                  condition
              );
              if (nestedResult) return nestedResult;
            }
            return null;
          })
          .find((item) => item !== null);

      return result || null;
    },
    see_button() {
      this.$router.push({
        path: "/company",
        query: {
          detail_show: true,
          exhibitor_long_id: this.detail_company.exhibitor_long_id,
        },
      });
    },
    async go_to_detail(query) {
      this.loading = true;
      await this.get_product_detail(query.product_long_id);
      await this.get_company_detail(this.product_detail.exhibitor_long_id);
      this.detail_show = query.detail_show;
      this.loading = false;
    },
    query_change(data) {
      this.cid = data.select_value;
      this.page_no = data.pageNo;
      this.label_value = data.label_value;
      if (this.langSet == "cn") {
        this.product_name = data.search_input;
        this.en_product_name = "";
      } else {
        this.product_name = "";
        this.en_product_name = data.search_input;
      }
      this.get_lists();
    },
    async get_lists() {
      let data = {
        product_name: this.product_name,
        en_product_name: this.en_product_name,
        cid1: this.cid,
        page_no: this.pageNo,
        page_size: this.pageSize,
        label: this.label_value,
      };
      const res = await product_lists(data);
      this.productLists = res.data.lists;
      this.total = res.data.count;
    },
    async get_categoryLists() {
      const res = await categoryLists();
      this.search_options = res.data.lists;
    },
    currentChange(e) {
      this.pageNo = e;
      this.get_lists();
    },
    sizeChange(e) {
      this.pageSize = e;
      this.get_lists();
    },
    async item_click(item) {
      await this.get_product_detail(item.product_long_id);
      await this.get_company_detail(item.exhibitor_long_id);
      this.details_show_change();
    },
    async get_product_detail(product_long_id) {
      const product_res = await product_detail({
        product_long_id: product_long_id,
      });
      this.product_detail = product_res.data;
    },
    async get_company_detail(exhibitor_long_id) {
      const company_res = await company_detail({
        exhibitor_long_id: exhibitor_long_id,
      });
      this.detail_company = company_res.data;
    },
    details_show_change() {
      this.detail_show = !this.detail_show;
      window.scrollTo(0, 0)
    },
    request_click() {
      if (this.flag == "isLogin") {
        this.dialogVisible = true;
      } else {
        this.$message.warning("请先登录");
        setTimeout(function () {
          router.replace({
            path: "/login",
          });
        }, 1000);
      }
    },

    handleClose(done) {
      done();
    },
    async collect() {
      if (this.flag == "isLogin") {
        let data = {
          action: this.product_detail.is_collect == 0 ? 1 : 0,
          type: "product",
          dataid: this.product_detail.id,
        };
        const res = await public_collect(data);
        const product_res = await product_detail({
          product_long_id: this.product_detail.product_long_id,
        });
        this.product_detail = product_res.data;
        this.$message({
          message: res.msg,
          type: "success",
        });
      } else {
        this.$message.warning("请先登录");
        setTimeout(function () {
          router.replace({
            path: "/login",
          });
        }, 1000);
      }
    },
    async submit() {
      let data = {
        product_long_id: this.product_detail.product_long_id,
        content: this.request_content,
      };
      const res = await MemberConsultation_add(data);
      if (res.code == 1) {
        this.$message({
          message: res.msg,
          type: "success",
        });
        this.dialogVisible = false;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },

    // 字典 产品标签
    async get_dict_lists() {
      const res = await dict_lists({type: "product_label"});
      this.label_list = res.data.product_label;
      this.label_list.unshift({
        id: 999,
        name: "全部产品",
        name_en: "All Products",
        type_value: "product_label",
        value: "",
      });
    },
  },
};
</script>


<style scoped lang="scss">
.content_list {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}

._search {
  margin: 40px 0 20px 0;
}

.list_item {
  padding: 15px;
  //width: 305px;
  height: 280px;
  background: #f7f8fa;
  box-sizing: border-box; /* 确保内边距/边框不影响宽度 */
  text-align: center;
  flex: 0 0 calc(25% - 20px); /* 25%宽度减去左右外边距 */
  margin: 10px;
  overflow: hidden;
  cursor: pointer;
}

.image_box {
  //width: 275px;
  height: 155px;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 22px;
}

.item_img {
  width: 135px !important;
  height: 135px !important;
}

.margin_bottom {
  width: 100%;
  margin-bottom: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item_text1 {
  font-weight: 600;
  font-size: 20px;
  color: #2c2c2e;
  line-height: 28px;
  text-align: left;
  font-style: normal;
}

.item_text2 {
  font-weight: 400;
  font-size: 18px;
  color: #757575;
  line-height: 25px;
  text-align: left;
  font-style: normal;
}

/deep/ .el-pagination {
  text-align: center;
  margin: 50px 0 100px 0;
}

//详情
.company_box {
  //width: 1280px;
  height: 128px;
  background: #004190;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  margin: 40px 0 30px 0;
}

.company_box_left {
  //width: 60%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

._left_image_box {
  width: 160px;
  height: 90px;
  background: #ffffff;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 30px;
}

.image_left {
  object-fit: contain;
  width: 90px;
  height: 90px;
}

.company_title {
  font-weight: 600;
  font-size: 20px;
  color: #ffffff;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  margin-bottom: 10px;
}

.company_booth_no {
  margin-right: 80px;
  color: #ffffff;
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
  text-align: left;
  font-style: normal;
}

.company_enterprise_type {
  color: #ffffff;
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
  text-align: left;
  font-style: normal;
}

.see_button {
  width: 116px;
  height: 40px;
  background: #3d82d6;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}

.product_content {
  width: 100%;
  height: 480px;
  margin-bottom: 50px;
  padding: 30px;
  background: #f7f8fa;
  box-sizing: border-box;
}

.content_top {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 20px;
  color: #004190;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  margin-bottom: 20px;
}

.ball {
  display: flex;
}

.ball div:nth-child(1) {
  margin-left: 5px;
  width: 12px;
  height: 12px;
  background: #e62344;
  border-radius: 50%;
}

.ball div:nth-child(2) {
  margin-left: -2px;
  width: 12px;
  height: 12px;
  background: #004190;
  border-radius: 50%;
}

.content_middle {
  display: flex;
}

.middle_image_box {
  width: 280px;
  height: 158px;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 30px;
}

.middle_image {
  width: 135px;
  height: 135px;
}

.text_right {
}

.text_right > div:nth-child(1) {
  font-weight: 600;
  font-size: 20px;
  color: #2c2c2e;
  line-height: 28px;
  text-align: left;
  font-style: normal;
}

.Collection {
  width: 124px;
  height: 40px;
  background: #3d82d6;
  border-radius: 8px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-right: 15px;
}

.Collection_change {
  background: #e62344;
}

.Collection_image {
  width: 15px;
  height: 13px;
}

.Collection > div:nth-child(2) {
  margin: 0 10px;
}

.Request {
  width: 124px;
  height: 40px;
  background: #004190;
  border-radius: 8px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 20px;
  font-style: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.introduce_text {
  font-weight: 400;
  font-size: 18px;
  color: #2c2c2e;
  line-height: 25px;
  text-align: left;
  font-style: normal;
}

.margin_bottom20 {
  margin-bottom: 20px;
}

/deep/ .el-dialog__wrapper {
}

/deep/ .el-dialog {
  top: 5%;
  width: 480px !important;
  height: 445px !important;
  background: #ffffff;
  border-radius: 20px;
  position: relative;
}

/deep/ .el-dialog__footer {
  position: absolute;
  display: flex;
  margin: auto;
  left: 0;
  right: 0;
  justify-content: center;
  bottom: 0;
}

/deep/ .el-dialog__body {
  padding: 0 30px !important;
}

.line {
  width: 100%;
  border-bottom: 1px solid #f3f3f3;
}

.dialog_box_top {
  position: relative;
  display: flex;
  padding: 10px;
  align-items: center;
  height: 96px;
  background: #004190;
  border-radius: 8px;
  margin: 20px 0 15px 0;
}

.title_picture {
  position: relative;
  margin-right: 10px;
}

.title_picture > img:first-child {
  width: 65px;
  height: 65px;
  border-radius: 50%;
}

.title_picture > img:nth-child(2) {
  width: 20px;
  height: 20px;
  position: absolute;
  bottom: 0;
  right: 0;
}

.title_name {
  display: flex;
  margin-bottom: 5px;
  align-items: center;
}

.title_name > div:nth-child(1) {
  font-weight: 600;
  font-size: 18px;
  color: #ffffff;
  line-height: 25px;
  letter-spacing: 1px;
  text-align: center;
  font-style: normal;
}

.title_name > div:nth-child(2) {
  margin-left: 10px;
  font-weight: 400;
  font-size: 15px;
  color: #ffffff;
  line-height: 21px;
  text-align: center;
  font-style: normal;
}

.company {
  font-weight: 400;
  font-size: 15px;
  color: #ffffff;
  line-height: 21px;
  text-align: center;
  font-style: normal;
}

.edit_img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
}

.submit {
  width: 180px;
  height: 42px;
  border-radius: 9px;
  background-color: #004190;
  border-color: #004190;
}

.submit:hover {
  background-color: #004190;
  opacity: 0.9;
}

.submit:focus {
  background-color: #004190;
  opacity: 1;
}

/* 平板：一行3个 */
@media (max-width: 768px) {
  .flex-item {
    flex-basis: calc(33.33% - 10px);
  }
}

/* 手机：一行2个 */
@media (max-width: 480px) {
  .flex-item {
    flex-basis: calc(50% - 10px);
  }
}

@media only screen and (max-width: 767px) {
  .company_box {
    height: 2.08rem;
    padding: 0.38rem 0.29rem;
    box-sizing: border-box;
    margin: 0.38rem 0;

    ._left_image_box {
      width: 2.31rem;
      height: 1.3rem;
      margin-right: 0.19rem;

      .image_left {
        width: 2.31rem;
        height: 1.3rem;
      }
    }

    .company_title {
      font-size: 0.29rem;
      line-height: 0.4rem;
      margin-bottom: 0.1rem;
    }

    .mobile_flex {
      flex-wrap: wrap;

      .company_booth_no,
      .company_enterprise_type {
        font-size: 0.25rem;
        line-height: 0.35rem;
        margin-right: 0;
        width: 100%;
      }
    }

    .see_button {
      display: none;
    }
  }
  .product_content {
    height: auto;
    padding: 0.29rem;
    margin-top: 1.5rem;
    position: relative;

    .content_top {
      font-size: 0.31rem;
      line-height: 0.42rem;
      margin-bottom: 0.38rem;
    }

    .content_middle {
      flex-wrap: wrap;

      .middle_image_box {
        width: 100%;
        height: auto;
        margin-right: 0;
        margin-bottom: 0.38rem;
      }

      .text_right {
        width: 100%;

        > div {
          font-size: 0.29rem;
          line-height: 0.4rem;
        }

        .margin_bottom20 {
          margin-bottom: 0.38rem;
        }
      }
    }

    .mobile_btn {
      position: absolute;
      top: -1.1rem;
      left: 0;
      width: 100%;
      justify-content: center;
    }
  }
}
</style>